import BemIt, { addClass } from "@gtechdoodler/bem-it";
import Icon from "../../../imagery/Icon";
import StyledBadgeBase from "./BadgeBase.styles";
import Typography from "../../../typography/Typography";
import { BadgeBaseProps } from "./BadgeBase.types";
import { IconNameOptions } from "../../../imagery/Icon/Icon.types";
import { TypographyVariantOptions } from "../../../typography/Typography/Typography.types";
import { SpaceOptionsOrZero } from "../../../layout/Space/Space.types";
import { Unit } from "../../../../types/globals";

const typographyVariantMapping: {
	sm: TypographyVariantOptions;
	md: TypographyVariantOptions;
	lg: TypographyVariantOptions;
} = {
	sm: "body-small",
	md: "body",
	lg: "body-large",
};

const height: { sm: Unit; md: Unit; lg: Unit } = {
	sm: "24px",
	md: "32px",
	lg: "40px",
};

const paddingX: {
	sm: SpaceOptionsOrZero;
	md: SpaceOptionsOrZero;
	lg: SpaceOptionsOrZero;
} = {
	sm: "xs",
	md: "sm",
	lg: "md",
};

const BadgeBase: React.FC<BadgeBaseProps> = ({
	size = "lg",
	backgroundColor,
	icon,
	iconPosition = "left",
	text,
	className,
	...props
}) => {
	const block = new BemIt("BadgeBase");

	const getSpaceOptionForSize = () => {
		return size === "sm" || size === "md" ? "xxs" : "xs";
	};

	const getIconMarginRight = (): SpaceOptionsOrZero | undefined => {
		return iconPosition === "left" ? getSpaceOptionForSize() : undefined;
	};

	const getIconMarginLeft = () => {
		return iconPosition === "right" ? getSpaceOptionForSize() : undefined;
	};

	return (
		<StyledBadgeBase
			className={addClass(className).after(block.mod(size))}
			backgroundColor={backgroundColor}
			size={size}
			display="inline-flex"
			flexDirection={iconPosition === "left" ? "row" : "row-reverse"}
			alignItems="center"
			height={height[size]}
			paddingX={paddingX[size]}
			{...props}
		>
			{icon && (
				<Icon
					name={icon as IconNameOptions}
					size={size === "lg" ? "md" : "sm"}
					marginRight={getIconMarginRight()}
					marginLeft={getIconMarginLeft()}
				/>
			)}
			<Typography variant={typographyVariantMapping[size]} weight="heaviest">
				{text}
			</Typography>
		</StyledBadgeBase>
	);
};

export default BadgeBase;
